import React from 'react';
import './AlertBox.css';

interface AlertBoxProps {
  title: string;
  message: string;
  okAction: () => void;
  isVisible: boolean;
  onClose?: () => void;
  okText?: string;
}

const AlertBox: React.FC<AlertBoxProps> = ({ 
  title, 
  message, 
  okAction, 
  isVisible, 
  onClose,
  okText = 'OK'
}) => {
  if (!isVisible) return null;

  const handleOkClick = () => {
    okAction();
    if (onClose) {
      onClose();
    }
  };

  const handleBackdropClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget && onClose) {
      onClose();
    }
  };

  console.log('title', title);
  console.log('message', message);
  console.log('okAction', okAction);
  console.log('isVisible', isVisible);
  console.log('onClose', onClose);
  console.log('okText', okText);

  return (
    <div className="alert-box-overlay" onClick={handleBackdropClick}>
      <div className="alert-box">
        <div className="alert-box-header">
          <h3 className="alert-box-title">{title}</h3>
        </div>
        
        <div className="alert-box-content">
          <p className="alert-box-message">{message}</p>
        </div>
        
        <div className="alert-box-actions">
          <button 
            className="alert-box-button alert-box-button-primary"
            onClick={handleOkClick}
          >
            {okText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AlertBox;
